"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { trackAddToWishlist } from "@/lib/tracking/events";
import { addToWishlist, getWishlistIds, removeFromWishlist } from "./actions";
type WishlistContextValue = {
  isInWishlist: (productId: string) => boolean;
  toggle: (productId: string) => Promise<void>;
  count: number;
  isAuthenticated: boolean;
};
const WishlistContext = createContext<WishlistContextValue | null>(null);
export function WishlistProvider(t0) {
  const $ = _c(17);
  const {
    userId,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [productIds, setProductIds] = useState(t1);
  const isAuthenticated = Boolean(userId);
  let t2;
  let t3;
  if ($[1] !== userId) {
    t2 = () => {
      if (!userId) {
        setProductIds(new Set());
        return;
      }
      let cancelled = false;
      getWishlistIds().then(ids => {
        if (!cancelled) {
          setProductIds(new Set(ids));
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t3 = [userId];
    $[1] = userId;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== productIds) {
    t4 = productId => productIds.has(productId);
    $[4] = productIds;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const isInWishlist = t4;
  let t5;
  if ($[6] !== productIds || $[7] !== userId) {
    t5 = async productId_0 => {
      if (!userId) {
        return;
      }
      const wasInWishlist = productIds.has(productId_0);
      setProductIds(prev => {
        const next = new Set(prev);
        if (wasInWishlist) {
          next.delete(productId_0);
        } else {
          next.add(productId_0);
        }
        return next;
      });
      ;
      try {
        if (wasInWishlist) {
          await removeFromWishlist(productId_0);
        } else {
          await addToWishlist(productId_0);
          trackAddToWishlist(productId_0);
        }
      } catch (t6) {
        const err = t6;
        console.error("[wishlist] toggle error:", err);
        setProductIds(prev_0 => {
          const next_0 = new Set(prev_0);
          if (wasInWishlist) {
            next_0.add(productId_0);
          } else {
            next_0.delete(productId_0);
          }
          return next_0;
        });
      }
    };
    $[6] = productIds;
    $[7] = userId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const toggle = t5;
  let t6;
  if ($[9] !== isAuthenticated || $[10] !== isInWishlist || $[11] !== productIds.size || $[12] !== toggle) {
    t6 = {
      isInWishlist,
      toggle,
      count: productIds.size,
      isAuthenticated
    };
    $[9] = isAuthenticated;
    $[10] = isInWishlist;
    $[11] = productIds.size;
    $[12] = toggle;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== children || $[15] !== t6) {
    t7 = <WishlistContext.Provider value={t6}>{children}</WishlistContext.Provider>;
    $[14] = children;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export function useWishlist() {
  const ctx = useContext(WishlistContext);
  if (!ctx) {
    throw new Error("useWishlist must be used inside WishlistProvider");
  }
  return ctx;
}